<script setup lang="ts">
const props = defineProps({
  quote: {
    type: String as PropType<string>,
    required: true,
  },
})

const quote = useSimpleQuoteToQuoteType(props.quote)
</script>

<template>
  <blockquote
    class="relative my-16 w-full leading-8"
    :aria-label="
      quote.author && quote.company
        ? `sitat av ${quote.author} ${quote.company}`
        : `sitat`
    "
  >
    <IconsGraphicsQuoteSymbol
      class="hidden sm:absolute sm:-top-8 sm:-left-20 sm:block"
      fill="var(--background)"
      width="60"
      aria-hidden="true"
    />
    <mark
      class="my-32 font-headline text-2xl leading-11.25 font-normal sm:text-4xl sm:leading-13!"
      v-html="quote.body"
    />
    <div
      v-if="quote.author"
      class="mt-3 text-lg"
      aria-hidden="true"
    >
      <mark v-text="quote.author" />
    </div>
    <div
      v-if="quote.company"
      class="text-base leading-8"
      aria-hidden="true"
    >
      <mark v-text="quote.company" />
    </div>
  </blockquote>
</template>

<style scoped>
@reference "~/assets/styles/main.css";

mark {
  @apply text-green-50 p-1;
  background-color: color-mix(in oklab, var(--foreground) 30%, transparent 100%);
}
</style>
